import { Component, OnDestroy, OnInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/observable';
import { Subscription } from 'rxjs/Subscription';

import { ApplicationStatus } from '../../enums/application-status.enum';
import { EnumHelper } from '../../helpers/enum-helper';
import { Application } from '../../models/application';
import { Meetup } from '../../models/meetup';
import { ApplicationService } from '../../services/application.service';
import { MeetupService } from '../../services/meetup.service';
import { AddPaymentComponent } from '../add-payment/add-payment.component';
import { AddSponsorshipComponent } from '../add-sponsorship/add-sponsorship.component';
import { CancelApplicationComponent } from '../cancel-application/cancel-application.component';
import { CheckInApplicationComponent } from '../check-in-application/check-in-application.component';
import { ConfirmApplicationComponent } from '../confirm-application/confirm-application.component';
import { ForwardApplicationComponent } from '../forward-application/forward-application.component';

@Component({
	selector: 'app-applications',
	templateUrl: './applications.component.html',
	styleUrls: ['./applications.component.scss']
})
export class ApplicationsComponent implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;

	public applications: Observable<Application[]>;
	public meetups: Observable<Meetup[]>;
	public selectedMeetup: string;
	public enumHelper: typeof EnumHelper = EnumHelper;
	public statuses: typeof ApplicationStatus = ApplicationStatus;
	public statusValues: number[] = Object.values(ApplicationStatus).filter(e => typeof (e) == "number");

	constructor(private applicationService: ApplicationService,
		private dialog: MdDialog,
		private meetupService: MeetupService,
		private router: Router) {
		this.subscriptionManager = new Subscription();

		this.meetups = this.meetupService.getMeetups();
		this.subscriptionManager.add(this.meetupService.getNextMeetups().subscribe(next => {
			if (next.length > 0) {
				this.selectedMeetup = next[0].$key;
				this.getApplications(this.selectedMeetup);
			}
		}));
	}

	ngOnInit() { }

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public getApplications(meetupKey: string): void {
		this.applications = this.applicationService.getApplicationsByMeetup(meetupKey);
	}

	public add(): void {
		this.router.navigate(['add-application']);
	}

	public review(application: Application): void {
		this.router.navigate(['review-application', application.$key]);
	}

	public confirm(application: Application): void {
		let dialogRef = this.dialog.open(ConfirmApplicationComponent, {
			width: '300px'
		});

		this.subscriptionManager.add(dialogRef.afterClosed().subscribe(next => {
			if (next === 'Yes') {
				application.applicationStatus = ApplicationStatus.Confirmed;
				this.applicationService.updateApplication(application.$key, application);
			}
		}));
	}

	public addSponsorship(application: Application): void {
		let dialogRef = this.dialog.open(AddSponsorshipComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(application);
	}

	public addPayment(application: Application): void {
		let dialogRef = this.dialog.open(AddPaymentComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(application);
	}

	public checkIn(application: Application): void {
		let dialogRef = this.dialog.open(CheckInApplicationComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(application);
	}

	public forward(application: Application): void {
		let dialogRef = this.dialog.open(ForwardApplicationComponent, {
			width: '300px'
		});

		dialogRef.componentInstance.updateForm(application);
	}

	public cancel(application: Application): void {
		let dialogRef = this.dialog.open(CancelApplicationComponent, {
			width: '300px'
		});

		this.subscriptionManager.add(dialogRef.afterClosed().subscribe(next => {
			if (next === 'Yes') {
				application.applicationStatus = ApplicationStatus.Cancelled;
				this.applicationService.updateApplication(application.$key, application);
			}
		}));
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/applications/applications.component.ts